import { render, staticRenderFns } from "./TeamsSteps.vue?vue&type=template&id=5a5b8161&scoped=true"
import script from "./TeamsSteps.vue?vue&type=script&lang=js"
export * from "./TeamsSteps.vue?vue&type=script&lang=js"
import style0 from "./TeamsSteps.vue?vue&type=style&index=0&id=5a5b8161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b8161",
  null
  
)

export default component.exports